import { Controller } from "@hotwired/stimulus"

// vendor_customers/index: the "Pending only" switch saves the current
// user's view_zero_bal preference server-side, then reloads -- the actual
// zero-balance row filtering happens server-side in the .erb, so a plain
// reload is the simplest way to reflect the new preference.
export default class extends Controller {
  static values = { userId: Number }

  toggle(event) {
    const isChecked = event.target.checked

    fetch(`/update_user_view_zero/${this.userIdValue}`, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ user: { view_zero_bal: isChecked ? 0 : 1 } }),
    }).then(() => location.reload())
  }
}
